<template>
    <div class="dialog">
        <div class="dialog_detail">
            <div class="dialog_title">这是报名场控</div>
            <img :src="applyDate.popImageUrl" alt="">
            <div @click="close" class="dialog_btn">关闭</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "applyControl",
    props:['applyDate'],
    data() {
        return {

        }
    },

    methods: {
        close(){
            this.$emit('close')
        }
    },
}
</script>